import { useState } from "react";
import { Alert, Box, Card, CardContent, Stack, Typography } from "@mui/material";
import { GoogleLogin } from "@react-oauth/google";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";
import { GOOGLE_HOSTED_DOMAIN } from "@/config";

export function LoginPage() {
  const { user, loginWithGoogle } = useAuth();
  const [error, setError] = useState<string | null>(null);

  if (user) return <Navigate to="/" replace />;

  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 12 }}>
      <Card sx={{ maxWidth: 420, width: "100%" }}>
        <CardContent>
          <Stack spacing={2} alignItems="center">
            <Box component="img" src="/logo.png" alt="Freedom Power" sx={{ height: 44, mb: 1 }} />
            <Typography variant="h5">Approvals Dashboard</Typography>
            <Typography variant="body2" color="text.secondary" textAlign="center">
              Sign in with your Freedom Solar Google account.
            </Typography>
            {error && <Alert severity="error" sx={{ width: "100%" }}>{error}</Alert>}
            <GoogleLogin
              hosted_domain={GOOGLE_HOSTED_DOMAIN || undefined}
              onSuccess={async (resp) => {
                try {
                  setError(null);
                  await loginWithGoogle(resp.credential ?? "");
                } catch (e: unknown) {
                  const msg =
                    (e as { response?: { data?: { error?: string } } })?.response?.data?.error;
                  setError(msg ?? "Sign-in failed.");
                }
              }}
              onError={() => setError("Google sign-in failed.")}
            />
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
